/**
 * External Dependencies
 */
import { navbarMenu } from './modules/navbarMenu';
import { modal } from './modules/modal';
import loadMore from './modules/loadMore';

document.addEventListener("DOMContentLoaded", function () {
  navbarMenu();
  modal();
  loadMore.init();
});
